import script from "./termination-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./termination-modal.vue?vue&type=script&setup=true&lang=js"

import "./termination-modal.vue?vue&type=style&index=0&id=1c00396e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c00396e"]])

export default __exports__